<script setup lang="ts">
import DeviceMeta from '../DeviceMeta';
import type { PropType } from 'vue';
import type { Value } from '../Default/lib';
import type { MetaProps } from '../DeviceMeta/lib';

const waterBackground = new URL('../../assets/Wave.png', import.meta.url).href;

const props = defineProps({
  temp: {
    type: Object as PropType<Value>,
    default: undefined,
  },
  volume: {
    type: Object as PropType<Value>,
    default: undefined,
  },
  meta: {
    type: Object as PropType<MetaProps>,
    required: true,
  },
});
</script>

<template>
  <div
    class="w-full text-white font-light font-sans relative"
  >
    <div class="absolute left-0 top-12 right-0 bottom-0">
      <img
        class="w-full object-cover"
        :src="waterBackground"
      >
    </div>

    <div class="text-4xl">
      <div class="max-w-lg flex flex-row items-center justify-center m-auto h-56 ">
        <div
          v-if="props.volume"
          class="flex flex-col items-center justify-center w-full"
          :class="{ 'border-solid border-r-[0.5px] border-gray-600': props.temp && props.volume }"
        >
          <div>
            {{ props.volume.value }}{{ props.volume.unit }}
          </div>
          <div class="text-2xl text-[#a6a9a6]">
            {{ props.volume.name }}
          </div>
        </div>
        <div
          v-if="props.temp"
          class="flex flex-col items-center justify-center w-full text-4xl"
        >
          <div>
            {{ props.temp.value }}{{ props.temp.unit }}
          </div>
          <div class="text-2xl text-[#a6a9a6]">
            {{ props.temp.name }}
          </div>
        </div>
      </div>
    </div>

    <DeviceMeta
      v-if="props.meta"
      v-bind="props.meta"
    />
  </div>
</template>

<style scoped>
.waterComponent {
  background-image: url('../../assets/Wave.png');
  background-size: contain;
  background-repeat: no-repeat;
}
</style>

